export const contractCategories = [
  { label: "NORMAL", value: "NORMAL" },
  { label: "RCC", value: "RCC" },
  { label: "RMC", value: "RMC" },
  { label: "NORMAL COM PRESTAMISTA", value: "NORMAL COM PRESTAMISTA" },
  { label: "PRESTAMISTA", value: "PRESTAMISTA" },
  { label: "TETO INSS", value: "TETO INSS" },
];

export const allContractStatuses = [
  { label: "AJUIZAR", value: "AJUIZAR" },
  { label: "NÃO POSSUI ABUSIVIDADE", value: "NAO_POSSUI_ABUSIVIDADE" },
  { label: "FALTAM DOCUMENTOS", value: "FALTAM_DOCUMENTOS" },
  { label: "CANCELADO", value: "CANCELADO" },
  { label: "PROTOCOLO URGENTE", value: "PROTOCOLO_URGENTE" },
  { label: "PROTOCOLADO", value: "PROTOCOLADO" },
  { label: "TRÂNSITO EM JULGADO", value: "TRANSITO_EM_JULGADO" },
  { label: "REAJUIZAR", value: "REAJUIZAR" },
  { label: "PASTA FEITA", value: "PASTA_FEITA" },
  { label: "DESATUALIZADO", value: "DESATUALIZADO" },
];

export const STATUSES_ELIGIBLE_FOR_NON_ABUSIVE_PROMPT = new Set([
  "AJUIZAR",
  "REAJUIZAR",
]);

export const todayIsoDate = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const buildNewContractDraft = (currentDate, customer = null) => ({
  number: "",
  date: currentDate,
  category: "NORMAL",
  status: "AJUIZAR",
  customer: customer || 0,
  bank: 0,
  lawyer: null,
  lawyer_wallet: null,
  service_obs: "",
  process_protocol_obs: "",
  filed_at: null,
  file_at: null,
  state: "",
  process_number: "",
  complaint_protocol_number: "",
  sales_consultant: null,
  contracted_value: 0.0,
  installments: 0,
  installment_value: 0.0,
  contract_expenses_value: 0.0,
  installment_part_not_questioned_value: 0.0,
  installment_questioned_value: 0.0,
  interest_rate_monthly_value: 0.0,
  interest_rate_yearly_value: 0.0,
  contract_at: null,
  first_installment_at: null,
  grace_period_days: 0,
  installments_payed: 0,
  is_renegotiation: false,
  renegotiation_installments: 0,
  renegotiation_value: 0.0,
  contract_type: 0,
  interest_rate_average_monthly_value: 0.0,
  interest_rate_average_yearly_value: 0.0,
  updated_at: null,
  contract_installments: [],
  total_amortization: 0.0,
  total_installment_value: 0.0,
  total_overpaid_value: 0.0,
  total_legal_interest: 0.0,
  total_correction_value: 0.0,
  responsible_user: null,
  has_ajg: false,
  has_after_sales_video: false,
});

export const resolveContractId = (contractOrId) => {
  if (contractOrId == null || contractOrId === "") return null;
  if (typeof contractOrId === "object") return contractOrId.id ?? null;
  return contractOrId;
};

export const normalizeOpenNewContractOptions = (options = {}) => {
  const customer =
    options.customer && typeof options.customer === "object" ? options.customer : null;
  const customerId = options.customerId ?? customer?.id ?? null;
  return {
    customer,
    customerId: customerId || null,
    lockCustomer: Boolean(options.lockCustomer),
    onSaved: typeof options.onSaved === "function" ? options.onSaved : null,
  };
};
